<template>
  <v-card
    style="
      border-top-left-radius: 10px !important;
      border-top-right-radius: 10px !important;
    "
    :class="!isMobile ? 'card-desktop-style' : ''"
    v-if="loaded"
  >
    <v-card-title
      style="
        display: block !important;
        padding: 4px 16px 0 !important;
        text-align: center !important;
        height: 36px !important;
        font-weight: 500 !important;
        color: black !important;
        font-size: 1rem;
      "
      >Auftrag ändern
      <v-icon
        @click="resetAll"
        style="
          color: rgba(145, 145, 145, 0.8) !important;
          position: absolute !important;
          right: 8px !important;
          font-size: 1.5rem;
          margin-top: 4px !important;
        "
        >mdi-close-circle-outline</v-icon
      ></v-card-title
    >
    <v-divider />
    <v-form ref="form" class="pa-2 pt-0 fat-margin-bottom">
        <v-container style="overflow-y: auto !important;" :class="isMobile ? 'mobile-order-edit':'desktop-order-edit'" class="mt-0 pt-0">
        <v-card-text class="pa-0">
            <v-row
            no-gutters
            class="mt-0"
            style=" min-height: 40px; line-height: 40px;"
            >
            <dropdown-component
                :items="availableWasteTypes"
                :itemText="'description'"
                :itemKey="'id'"
                :itemMessage="'Abfallart wählen'"
                :labelName="'Abfallart'"
                :isClickable="true"
                :isPreselected="true"
                :notRequired="false"
                :isSmallDevice="true"
                @set-dropdown-value="setWasteType"
            />
            </v-row>
            <v-divider />
            <v-row
            v-if="order.agreement.wasteType.id !== 1 /* altreifen */"
            no-gutters
            class="mt-0"
            >
            <digit-changer
                :labelName="'Anzahl'"
                :initValue="order.amount"
                :maxValue="amountMax"
                @set-digit-value="setOrderAmount"
                :key="componentKey"
                :isSmallDevice="true"
                :isClickable="true"
            />
            </v-row>
            <v-divider />
            <v-row no-gutters class="mt-1">
            <dropdown-component
                data-cy="action"
                :labelName="'Aktion'"
                :isClickable="true"
                :items="containerActions"
                :isPreselected="true"
                :notRequired="true"
                @set-dropdown-value="setActionValue"
                :preselectedItem="{text: order.containerAction.description, value: order.containerAction.id}"
                :key="componentKey"
                itemKey="value"
                itemText="text"
                :isSmallDevice="true"
            />
            </v-row>
            <v-divider />
            <v-row no-gutters class="mt-2 mb-1">
            <special-date-component
                :labelName="'Wunschtermin'"
                :isClickable="true"
                :itemMessage="'Wunschtermin wählen'"
                @set-date-value="setOrderDateFromComponent"
                :key="componentKey"
                :isSmallDevice="true"
                :preselectedDate="order.desiredDate"
                :showDialog="true"
                :order="order"
                :isMobile="isMobile"
            />
            </v-row>
            <v-divider />
            <v-row no-gutters class="mt-2 mb-1">
            <v-card
            width="100%"
            class="pa-5"
            outlined
            color="#E5F8F4"
            v-if="isChanged"
            >
            <v-container
                class="pa-0"
                v-if="editedOrder.amount !== order.amount"
            >
                <p class="changes-header pa-0 ma-0">
                Änderung Anzahl:
                </p>
                <p class="changes-content">von {{ order.amount }} zu {{ editedOrder.amount }}</p>
            </v-container>
            <v-container
                class="pa-0"
                v-if="editedOrder.containerActionId !== order.containerActionId"
            >
                <p class="changes-header pa-0 ma-0">
                Änderung Aktion:
                </p>
                <p class="changes-content">von {{ containerActions.filter(c => c.value === order.containerActionId)[0].text }} zu {{ containerActions.filter(c => c.value === editedOrder.containerActionId)[0].text }}</p>
            </v-container>
            <v-container
                class="pa-0"
                v-if="editedOrder.wasteType.id !== previousWasteType.id"
            >
                <p class="changes-header pa-0 ma-0">
                Änderung Abfallart (Umdeklaration):
                </p>
                <p class="changes-content">
                von {{ previousWasteType.description }} zu
                {{ editedOrder.wasteType.description }}
                </p>
            </v-container>
            <v-container
                class="pa-0"
                v-if="editedOrder.desiredDate !== order.desiredDate && !isMobile"
            >
             <p class="changes-header pa-0 ma-0">
                Änderung Wunschtermin:
                </p>
                <p class="changes-content">
                von {{ oldDesiredDateFormatted }} zu {{ desiredDateFormatted }}
                </p>
            </v-container>
            <v-container
                class="pa-0"
                v-if="editedOrder.desiredDate !== order.desiredDate && isMobile"
            >
               <p> <span class="changes-header pa-0 ma-0">Von </span>
                 <span style="font-size:  0.75rem"> {{ oldDesiredDateFormatted }}</span>
                 </p>
                <p> <span class="changes-header pa-0 ma-0">zu </span>
                  <span style="font-size:  0.75rem"> {{ desiredDateFormatted }}</span> </p>
            </v-container>
            </v-card>
            </v-row>
        </v-card-text>
        </v-container>
        <v-container class="pa-0">
        <div class="text-center pb-1" style="padding-top: 10px !important;">
            <v-btn
            class="mt-1"
            color="primary"
            @click="validateForm"
            :min-width="isMobile ? '90%' : '70%'"
            min-height="50px"
            rounded
            :disabled="
                editedOrder.desiredDate === '' || editedOrder.desiredDate === null || !isChanged
            "
            >Jetzt ändern</v-btn
            >
        </div>
        </v-container>

        <confirm
        v-model="dialog"
        title="Folgenden Auftrag verbindlich ändern?"
        v-on:confirmed="updateOrder"
        ><v-row no-gutters class="mt-3">
            <justified-list
            labelName="Abfallart"
            :itemValue="editedOrder.wasteType.description"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-0">
            <justified-list
            labelName="Behältertyp"
            :itemValue="order.agreement.containerType.type"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-0">
            <justified-list
            labelName="Behältergröße"
            :itemValue="
                order.agreement.containerType.size
                ? order.agreement.containerType.size
                : '-'
            "
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row
            no-gutters
            class="mt-0"
            v-if="editedOrder.wasteType.id !== 1"
        >
            <justified-list
            :labelName="amountLabel"
            :itemValue="editedOrder.amount.toString()"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider v-if="order.agreement.wasteType.id !== 1" />
        <v-row no-gutters class="mt-0">
            <justified-list
            labelName="Aktion"
            :itemValue="containerActions.filter(c => c.value === editedOrder.containerActionId)[0].text"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-0">
            <justified-list
            labelName="Auftrags-Nr."
            :itemValue="
                order.externalOrderId
                ? order.externalOrderId
                : '-'
            "
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-0">
            <justified-list
            :labelName="`Wunschtermin (${actionNoun})`"
            :itemValue="desiredDateFormatted"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
        <v-row no-gutters class="mt-0">
            <justified-list
            labelName="Hinweis für den Entsorger"
            :itemValue="order.hint ? order.hint : '-'"
            :isSmallDevice="true"
            />
        </v-row>
        <v-divider />
            <v-row no-gutters class="mt-2 mb-1">
            <v-card
            width="100%"
            class="pa-5"
            outlined
            color="#E5F8F4"
            v-if="isChanged"
            >
            <v-container
                class="pa-0"
            >
                <p class="changes-header pa-0 ma-0">
                Sie beauftragen folgende(n) {{actionNoun}}:
                </p>
                <p class="changes-content">{{ editedOrder.amount }} x {{ order.agreement.containerType.type }} {{ order.agreement.containerType.size }}</p>
            </v-container>
            </v-card>
            </v-row>
            <v-row no-gutters class="mt-2 mb-1">
            <v-card
            width="100%"
            class="pa-5"
            outlined
            color="#E5F8F4"
            v-if="isChanged"
            >
            <v-container
                class="pa-0"
            >
                <p class="changes-header pa-0 ma-0">
                Hinweis: Auflösung der Vereinbarung
                </p>
                <p class="changes-content">Nach Abzug aller Behälter der Vereinbarung, wird die Vereinbarung automatisch gelöscht. Bis zum Abzug der Behälter können weiterhin Entsorgungen beauftragt werden. Bereits beauftragte Entsorgungen bleiben bestehen und finden wie geplant statt.</p>
            </v-container>
            </v-card>
            </v-row>
        </confirm>
    </v-form>


    <loading-component :isLoading="isLoading" />
  </v-card>
</template>

<script>
import Vue from "vue";
import DigitChanger from "@/components/atoms/DigitChanger.vue";
import DropdownComponent from "@/components/atoms/DropdownComponent.vue";
import SpecialDateComponent from "@/components/atoms/SpecialDateComponent.vue";
import LoadingComponent from "./atoms/LoadingComponent.vue";
import { dateFormat, ContainerAction } from "@/helpers";
import Confirm from "@/components/atoms/Confirm.vue";
import JustifiedList from "@/components/atoms/JustifiedList.vue";
import { mapState } from "vuex";
import axios from "axios";
import { ApiUrl } from "@/config/ApiUrl";

export default Vue.extend({
  components: {
    LoadingComponent,
    SpecialDateComponent,
    DropdownComponent,
    DigitChanger,
    Confirm,
    JustifiedList
  },
  props: {
    order: Object,
    editKey: Number,
    subComponentKey: Number
  },
  data: () => {
    return {
      isLoading: false,
      dialog: false, // confirmation dialog
      containerActions: [{}],
      editedOrder: {
        wasteType: {},
        containerActionId: 0,
        amount: 0,
        orderDate: "",
        desiredDate: ""
      },
      openOrderCount: 0,
      desiredDateFormatted: "",
      oldDesiredDateFormatted: "",
      componentKey: 0,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      typesForAgreement: state => state.company.typesForAgreement
    }),
    isMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    amountLabel() {
      if (this.order.agreement.containerType.type === "Lose Abholung") {
        return "Kubikmeter";
      }
      if (
        this.order.agreement.containerType.type === "Big Bag" ||
        this.order.agreement.containerType.type === "Sammelsack"
      ) {
        return "Stück";
      }
      return "Anzahl";
    },
    amountMax() {
      if (
        this.order.agreement.containerType.type === "Big Bag" ||
        this.order.agreement.containerType.type === "Sammelsack" ||
        this.order.agreement.containerType.type === "Lose Abholung" || this.editedOrder.containerActionId === ContainerAction.STELLEN
      ) {
        return 10;
      }
      return this.order.agreement.amount;
    },
    isChanged() {
      if (
        this.editedOrder.amount !== this.order.amount ||
        (this.editedOrder.wasteType.id !== this.previousWasteType.id) ||
        this.editedOrder.desiredDate !== this.order.desiredDate ||
        this.editedOrder.containerActionId !== this.order.containerActionId
      ) {
        return true;
      } else {
        return false;
      }
    },
    actionNoun() {
      return this.editedOrder.containerActionId === ContainerAction.STELLEN ? "Stellung" :
        this.editedOrder.containerActionId === ContainerAction.TAUSCHEN ? "Tausch" :
          this.editedOrder.containerActionId === ContainerAction.ABZIEHEN ? "Abzug" :
            this.editedOrder.containerActionId === ContainerAction.LEEREN ? "Leerung" :
              this.editedOrder.containerActionId === ContainerAction.KAUF ? "Kauf" :
                this.editedOrder.containerActionId === ContainerAction.SOFORTBEFÜLLUNG ? "Sofortbefüllung" : "Abholung";
    },
    availableWasteTypes() {
      const newList = this.typesForAgreement.wasteTypes.filter(w => (w.containers.split(",")).includes(this.order.agreement.containerTypeId.toString()));
      const initialSelectedId = this.order.independentWasteTypeId !== 0 ? this.order.independentWasteTypeId : this.order.agreement.wasteTypeId;
      const originalIndex = newList.findIndex(w => w.id === initialSelectedId);
      const initialSelectedWaste = newList.splice(originalIndex,1)[0];
      newList.splice(0,0,initialSelectedWaste);
      return newList;
    },
    previousWasteType() {
      let wasteType;
      if(this.order.independentWasteTypeId !== 0) {
        wasteType = this.typesForAgreement.wasteTypes.filter(w => w.id === this.order.independentWasteTypeId)[0];
      } else {
        wasteType = this.order.agreement.wasteType;
      }
      return wasteType;
    }
  },
  async created() {
    this.$store.dispatch("getTypesForAgreement");
    window.setTimeout(() => {
      this.loaded = true;
    }, 500);
    this.editedOrder.amount = this.order.amount;
    this.editedOrder.desiredDate = this.order.desiredDate;
    this.editedOrder.wasteType = this.order.agreement.wasteType;
    this.editedOrder.desiredDate = this.order.desiredDate;
    this.desiredDateFormatted = dateFormat(this.order.desiredDate);
    this.oldDesiredDateFormatted = dateFormat(this.order.desiredDate);
    this.editedOrder.containerActionId = this.order.containerActionId;
    const actions = [];
    const actionLabels = [];
    const ctype = this.order.agreement.containerType;
    // when own container only Tauschen is possible
    if (this.order.agreement.ownContainer) {
      actions.push({
        value: ContainerAction.TAUSCHEN,
        text: "Tauschen"
      });
      actionLabels[2] = "Tauschen";
    } else {
      if (this.order.containerActionId !== ContainerAction.SOFORTBEFÜLLUNG && this.order.containerActionId !== ContainerAction.KAUF && this.order.containerActionId !== ContainerAction.ABHOLEN && this.order.containerActionId !== ContainerAction.STELLEN){
        if(this.order.containerActionId !== ContainerAction.ABZIEHEN){
          actions.push({
            value: ContainerAction.STELLEN,
            text: "Stellen"
          });
          actionLabels[ContainerAction.STELLEN] = "Stellen";
        }
        if (ctype.containerAction1) {
          if(this.order.containerActionId !== ContainerAction.STELLEN || (this.order.containerActionId === ContainerAction.STELLEN && ctype.containerAction1.id !== ContainerAction.LEEREN && this.order.agreement.amount > 1)) {
            actions.push({
              value: ctype.containerAction1.id,
              text: ctype.containerAction1.description
            });
            actionLabels[ctype.containerAction1.id] =
              ctype.containerAction1.description;
          }
        }
        if (ctype.containerAction2) {
          if(this.order.containerActionId !== ContainerAction.STELLEN) {
            actions.push({
              value: ctype.containerAction2.id,
              text: ctype.containerAction2.description
            });
            actionLabels[ctype.containerAction2.id] =
              ctype.containerAction2.description;
          }
        }
      } else {
        actions.push({
          value: this.order.containerAction.id,
          text: this.order.containerAction.description
        });
        actionLabels[this.order.containerAction.id] = this.order.containerAction.description;
      }
    }
    const originalIndex = actions.findIndex(a => a.value === this.order.containerAction.id);
    const initialSelectedAktion = actions.splice(originalIndex,1)[0];
    actions.splice(0,0,initialSelectedAktion);
    this.actionLabels = actionLabels;
    this.containerActions = actions;
  },
  methods: {
    validateForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.dialog = true;
    },
    setOrderAmount(amountValue) {
      this.editedOrder.amount = amountValue;
    },
    setActionValue(actionValue) {
      this.editedOrder.containerActionId = actionValue;
    },
    setOrderDateFromComponent(dateValue) {
      this.editedOrder.desiredDate = dateValue;
      this.desiredDateFormatted = dateFormat(dateValue);
      this.newSelectedDate = dateFormat(dateValue);
    },
    resetAll() {
      this.componentKey += 1;
      this.$emit("close-edit-dialog");
      this.isLoading = false;
    },
    updateOrder() {
      this.isLoading = true;
      const payload = {
        wasteTypeId: this.editedOrder.wasteType.id,
        containerActionId: this.editedOrder.containerActionId,
        amount: this.editedOrder.amount,
        desiredDate: this.editedOrder.desiredDate,
      };
      axios
        .request({
          method: "patch",
          url: `${ApiUrl.EDIT_ORDER}/${this.order.id}`,
          data: payload
        })
        .then(res => {
          this.$toast("Auftrag wurde erfolgreich geändert!");
          this.$emit("success-edit-dialog");
          this.isLoading = false;
          this.dialog = false;
        })
        .catch(err => {
          this.$toast.error(err.response.data.error.message);
          this.$emit("close-edit-dialog");
          this.isLoading = false;
          this.dialog = false;
        });
    },
    setWasteType(wasteTypeValue) {
      this.editedOrder.wasteType = this.typesForAgreement.wasteTypes.find(
        item => {
          if (item.id === wasteTypeValue) {
            return item;
          }
        }
      );
    }
  }
});
</script>

<style scoped>
.card-desktop-style {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.desktop-order-edit {
  max-height: 500px !important;
}

.mobile-order-edit {
  max-height: 60vh !important;
}
.changes-header {
  font-size: 0.75rem !important;
  font-weight: bold;
  color: #00B791 !important;
}
.changes-content {
  font-size: 0.75rem !important;
}
</style>
